import {useRoute} from '@react-navigation/native';
import {
  Alert,
  ButtonBorder,
  Div,
  HeaderBack,
  ImageView,
  Label,
} from 'components';
import {Ecolors, Icons} from 'constant';
import React, {useEffect, useRef, useState} from 'react';
import {useSafeAreaInsets} from 'react-native-safe-area-context';
import {
  apiAuth,
  CCCDConversionResult,
  configEkyc,
  convertDaTaCCCD,
  goBack,
  mappingEkycRejectContent,
  navigate,
} from 'services';
import {useAppSelector} from 'store/hooks';
import {Log} from 'utils';
import {getStoreToken} from 'utils/storage';
import LangJson from '../../../../trueidsdk/lang.json';

const ControlCMNDScreen = () => {
  const currentUser = useAppSelector<any>(state => state.authen.currentUser);
  const {statusScreen} = useAppSelector(state => state.authen);
  const insets = useSafeAreaInsets();
  const countTime = useRef<number>(1);
  const I18nState = useAppSelector(state => state.languages.I18nState);
  const flag = useRef<boolean>(false);
  const [sdkReady, setSdkReady] = useState(false);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    importSDK();
    return () => {};
  }, []);

  const importSDK = () => {
    try {
      import('../../../../trueidsdk/TrueIDSDK')
        .then(() => setSdkReady(true))
        .catch(() => setSdkReady(false));
    } catch (error) {
      importSDK();
    }
  };

  const handleEKYCError = (scanData: CCCDConversionResult) => {
    const content = mappingEkycRejectContent(scanData.rule_table);
    if (countTime.current > 2) {
      Alert.show({
        type: 2,
        titleClose: `alert.dongy`,
        content: `alert.ekycfail3`,
        multilanguage: true,
        onClose: () => {
          if (statusScreen === 'main') {
            goBack().then(() => {
              navigate('AccountVerifyScreen');
            });
            return;
          }
          navigate('LoginScreen');
        },
      });
      return;
    }
    Alert.showError({
      content: content || `alert.ekycfail`,
      onPress: () => {
        countTime.current += 1;
      },
    });
  };

  const handleSuccessfulScan = (scanData: CCCDConversionResult) => {
    const ruleTableArr = scanData?.rule_table?.find(
      (a: any) => a.group_code == 'LD',
    );
    const ruleLD001 = ruleTableArr?.rules?.find(
      (x: any) => x.rule_code == 'LD-001',
    );
    if (scanData?.decision?.code == -1 || ruleLD001?.check_result == 2) {
      if (countTime.current > 2) {
        Alert.show({
          type: 2,
          titleClose: `alert.dongy`,
          content: `alert.ekycfail3`,
          multilanguage: true,
          onClose: () => {
            navigate('AccountVerifyScreen');
            return;
          },
        });
        return;
      } else {
        Alert.showError({
          content: `alert.ekycfail`,
          onPress: () => {
            countTime.current += 1;
          },
        });
        return;
      }
    } else {
      navigate('ReviewInfoCMNDModal', {
        data: {
          ...scanData,
          currentUser: {
            ...currentUser,
          },
        },
      });
    }
  };

  const gotoEKYC = async () => {
    try {
      if (flag.current) {
        return;
      }
      flag.current = true;
      setLoading(true);
      const token = await getStoreToken();

      if (window?.['TrueIDSDK'] && window?.['TrueIDSDK'].start) {
        let configEKYC_ = {
          ...configEkyc,
          accessToken: token || '',
        };
        Log('configEKYC_', {configEKYC_, I18nState});
        window?.['TrueIDSDK'].setLanguageJson(I18nState, LangJson);
        window?.['TrueIDSDK'].start(configEKYC_, bindReviewInfo);
      } else {
        Log('NULL');
      }
    } catch (error: any) {
      setLoading(false);
      // Alert.showError({
      //   multilanguage: false,
      //   content: I18nState == 'vi' ? error.message : error.messageEn,
      // });
      Log('error>', error);
    } finally {
      flag.current = false;
      setLoading(false);
    }
  };

  const bindReviewInfo = async (scanData: any) => {
    if (!scanData) return;

    const dataObj = await convertDaTaCCCD(scanData);

    if (scanData?.decision?.code == -1) {
      handleEKYCError(dataObj);
      return;
    }
    handleSuccessfulScan(dataObj);
    return;
  };

  return (
    <Div height={'100%'} backgroundColor={Ecolors.whiteColor}>
      <HeaderBack
        // isShowStep={true}
        onPressBack={() => {
          goBack();
        }}
        type={4}
        title={`setpasswordscreen.titletrong`}
      />

      <Div flex={1} paddingHorizontal={29}>
        <Div width={'100%'} alignItems={'center'}>
          <Label
            marginTop={30}
            textAlign={'center'}
            size={20}
            fontWeight={'700'}>
            {`changecmnd.xacthucthongtin`}
          </Label>
          <Label marginTop={6} textAlign={'center'} size={14} lineHeight={20}>
            {`changecmnd.ekyccontent`}
          </Label>
        </Div>
        <Label marginTop={40} size={14} lineHeight={20}>
          {`controlekyc.chuphinhmattruoc`}
        </Label>
        <Div
          flexDirection={'row'}
          marginTop={17}
          alignItems={'center'}
          justifyContent={'flex-start'}>
          <ImageView
            width={132}
            height={80}
            resizeMode={'contain'}
            source={Icons.before}
            marginRight={11}
          />
          <ImageView
            resizeMode={'contain'}
            width={132}
            height={80}
            source={Icons.after}
          />
        </Div>

        <Label marginTop={18} size={14} lineHeight={20}>
          {`controlekyc.chuphinhchandung`}
        </Label>
        <Div>
          <ImageView
            marginTop={17}
            width={132}
            height={80}
            source={Icons.cmnd}
            resizeMode={'contain'}
          />
        </Div>
      </Div>
      <Div alignItems={'center'} paddingBottom={insets.bottom + 20}>
        <ButtonBorder
          isDisable={!sdkReady}
          loading={loading}
          onPress={() => {
            gotoEKYC();
          }}
          type={1}
          title={'controlekyc.batdau'}
        />
      </Div>
    </Div>
  );
};

export default React.memo(ControlCMNDScreen);
